import React from 'react'
import { NavLink } from 'react-router-dom'
import './Menulist.css'

export default function Menulist() {
  return (
    <>
      <ul className='menu-list'>
        <li className='menu-list-item active'><NavLink to='/admin'><i className='fa fa-home'></i>Home</NavLink></li>
        <li className='menu-list-item'><NavLink to='/admin/maincategory'><i className='fa fa-list'></i>Maincategory</NavLink></li>
        <li className='menu-list-item'><NavLink to='/admin/subcategory'><i className='fa fa-list'></i>Subcategory</NavLink></li>
        <li className='menu-list-item'><NavLink to='/admin/brand'><i className='fa fa-list'></i>Brand</NavLink></li>
        <li className='menu-list-item'><NavLink to='/admin/product'><i className='fa fa-list'></i>Product</NavLink></li>
        <li className='menu-list-item'><NavLink to='/admin/testimonial'><i className='fa fa-star'></i>Testimonial</NavLink></li>
        <li className='menu-list-item'><NavLink to='/admin/users'><i className='fa fa-users'></i>Users</NavLink></li>
        <li className='menu-list-item'><NavLink to='/admin/newsletter'><i className='fa fa-envelope'></i>Newletters</NavLink></li>
        <li className='menu-list-item'><NavLink to='/admin/contacts'><i className='fa fa-phone'></i>Contacts</NavLink></li>
        <li className='menu-list-item'><NavLink to='/admin/checkout'><i className='fa fa-shopping-bag'></i>Orders</NavLink></li>
      </ul>

    </>
  )
}
